import {Card, Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import {InputMaskedRegistrationNumberV2} from "../../../Common/Component/Input/InputMaskedRegistrationNumberV2";
import HttpRequest from "../../../Common/Http/HttpRequest";
import {Loading} from "../../../Common/Component/Loading/Loading";
import {CustomForm} from "./CustomForm";
import FormSchemaConfig from "../../../Common/Schema/FormSchemaConfig";
import DynamicCustomSelectorV2 from "../DynamicCustomSelectorV2";
import DynamicFileUploader from "../../../Common/Component/FileUpload/DynamicFileUploader";

export const FormComponentV2 = ({entity, id, onSaveAction, onCancelAction}) => {

    const [pageSchema, setPageSchema] = useState({
        isLoading: true
    });

    const formatUiSchema = (uiSchema) => {
        Object.keys(uiSchema)
            .filter(x => !['ui:description', 'ui:options', 'ui:widget', 'ui:autofocus', 'customSelect', 'ui:help'].includes(x))
            .forEach(prop => {

                const schema = uiSchema[prop];

                formatUiSchema(schema);

                if (schema.customSelect) {

                    if (schema.customSelect.component === 'EntitySelector') {
                        schema["ui:field"] = (props) => {
                            return (<DynamicCustomSelectorV2
                                    pathToCreate={`/select/form/${schema.customSelect.ref}`}
                                    title={schema.customSelect.title}
                                    isMulti={schema.customSelect.multiple}
                                    entitySchema={schema.customSelect.ref}
                                    disabled={props.disabled}
                                    required={props.required}
                                    value={props.formData}
                                    setValue={props.onChange}/>
                            );
                        }
                    }

                    if (schema.customSelect.component === 'MaskedInput') {
                        schema["ui:field"] = (props) => {
                            return (
                                <InputMaskedRegistrationNumberV2 title={props.schema.title}
                                                                 mask={props.schema.mask}
                                                                 disabled={props.disabled}
                                                                 required={props.required}
                                                                 value={props.formData}
                                                                 onChangeText={props.onChange}
                                />
                            );
                        }
                    }

                    if (schema.customSelect.component === 'FileUpload') {

                        schema["ui:field"] = (props) => {
                            return (<DynamicFileUploader
                                    {...props}
                                    generateUploadUrl={schema.customSelect.ref}
                                    label={props.schema.title}
                                    disabled={props.disabled}
                                    required={props.required}
                                    value={props.formData}
                                    setValue={props.onChange}
                                />
                            );
                        }
                    }


                }


            });


        return uiSchema;

    }

    const loadSchema = async () => {
        const formSchemaConfig = new FormSchemaConfig();
        const responseSchema = await formSchemaConfig.getFormSchemaByName(entity, {id});

        const getSaveUrl = responseSchema.getSaveUrl ? responseSchema.getSaveUrl : (id) => {
            return 'node/crud/entity/' + entity + (id ? `/${id}` : '');
        };

        const getByIdUrl = responseSchema.getByIdUrl ? responseSchema.getByIdUrl : (id) => 'node/crud/entity/' + entity + '/' + id

        const formSchema = responseSchema.getFormSchema ? responseSchema.getFormSchema(entity, {id}) : responseSchema.formSchema

        const schema = {
            isLoading: false,
            formSchema: formSchema,
            uiSchema: formatUiSchema(responseSchema.uiSchema),
            getSaveUrl,
            formatObjectToGet: responseSchema.formatObjectToGet,
            formatObjectToSave: responseSchema.formatObjectToSave
        };


        if (id) {
            HttpRequest.get(getByIdUrl(id)).then(x => {
                schema.originalFormData = schema.formatObjectToGet ? schema.formatObjectToGet(x) : x;
                schema.dataId = id;
                setPageSchema(schema)
            });
        } else {
            setPageSchema(schema)
        }
    }

    useEffect(() => {
        loadSchema();
    }, [id, entity]);

    if (!pageSchema) {
        return <Loading/>
    }

    if (pageSchema.isLoading) {
        return <Loading/>
    }

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col>
                        <CustomForm pageSchema={pageSchema} onSaveAction={onSaveAction}
                                    onCancelAction={onCancelAction}/>
                    </Col>
                </Row>

            </Card.Body>
        </Card>)
}
